import { Link } from 'react-router-dom';

import styled, { css } from 'styled-components';

import colors from 'theme/colors';
import fonts from 'theme/fonts';
import media from 'theme/media';

const getColor = (props) => {
    switch (props.variant) {
        case 'tertiary':
            if (props.disabled) {
                return props.useThemeColor ? props.theme.grey_40_lc : colors.lightGray;
            }
            return props.useThemeColor ? props.theme.black : colors.baseColor;
        case 'row':
            if (props.disabled) {
                return props.useThemeColor ? props.theme.purple_40_tr : colors.purpleRgba40;
            }
            return props.useThemeColor ? props.theme.purple_100 : colors.purple;
        default:
            return props.useThemeColor ? props.theme.white : colors.white;
    }
};

const disabledLinearGradient = `linear-gradient(0deg, ${colors.purpleRgba24}, ${colors.purpleRgba24}), ${colors.white}`;

const getBackground = (props) => {
    if (props.variant === 'primary' || !props.variant) {
        return props.disabled ? disabledLinearGradient : colors.purple;
    }
    return props.useThemeColor ? props.theme.white : colors.white;
};

const getHoveredBackground = (props) => {
    switch (props.variant) {
        case 'tertiary':
            return props.disabled ? colors.white : colors.porcelain;
        case 'row':
            if (props.disabled) {
                return props.useThemeColor ? props.theme.white : colors.white;
            }
            return props.useThemeColor ? props.theme.purple_8_tr : colors.purpleRgba08;
        default:
            return props.disabled ? disabledLinearGradient : `linear-gradient(0deg, ${colors.whiteRgba24}, ${colors.whiteRgba24}), ${colors.purple}`;
    }
};

const getBoxShadow = (props) => {
    const raised = props.raised && !props.disabled;
    if (props.variant === 'primary' || !props.variant) {
        return raised ? `0px 8px 8px ${colors.purpleRgba16}` : 'none';
    }
    return raised ? `0 0 1px ${colors.codGray12}, 0 0 8px ${colors.codGray04}, 0 8px 8px ${colors.codGray04}` : 'none';
};

const getMobilePadding = (props) => {
    if (props.variant === 'row') {
        return props.size === 'tight' ? '16px 24px' : '24px';
    }
    return props.size === 'tight' ? '8px 16px' : '16px 32px';
};
const getDesktopPadding = (props) => {
    if (props.variant === 'row') {
        return props.size === 'tight' ? '20px 32px' : '32px';
    }
    return props.size === 'tight' ? '12px 24px' : '20px 40px';
};
const getMobileRadius = (props) => {
    if (props.variant === 'row') {
        return '0';
    }
    return props.size === 'tight' ? '32px' : '56px';
};
const getDesktopRadius = (props) => {
    if (props.variant === 'row') {
        return '0';
    }
    return props.size === 'tight' ? '56px' : '72px';
};
const getMobileWidth = (props) => {
    return props.variant === 'row' && props.negativeMargin ? 'calc(100% + 48px)' : props.variant === 'row' ? '100%' : 'auto';
};
const getDesktopWidth = (props) => {
    return props.variant === 'row' && props.negativeMargin ? 'calc(100% + 64px)' : props.variant === 'row' ? '100%' : 'auto';
};

const CommonCss = css`
    font-family: ${fonts.regular};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    border: none;
    width: ${(props) => getMobileWidth(props)};
    box-sizing: border-box;
    display: inline-block;
    outline: none;
    text-align: ${(props) => (props.variant === 'row' && !props.textCenter ? 'left' : 'center')};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    vertical-align: top;
    cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
    pointer-events: auto;
    font-size: 17px;
    line-height: 24px;
    border-radius: ${(props) => getMobileRadius(props)};
    padding: ${(props) => getMobilePadding(props)};
    color: ${(props) => getColor(props)};
    background: ${(props) => getBackground(props)};
    box-shadow: ${(props) => getBoxShadow(props)};
    margin: ${(props) => (props.negativeMargin ? '0 -24px' : null)};

    ${media.desktop1920} {
        font-size: 20px;
        line-height: 32px;
        border-radius: ${(props) => getDesktopRadius(props)};
        padding: ${(props) => getDesktopPadding(props)};
        margin: ${(props) => (props.negativeMargin ? '0 -32px' : null)};
        width: ${(props) => getDesktopWidth(props)};
    }

    &:link,
    &:visited,
    &:focus {
        color: ${(props) => getColor(props)};
    }

    &:hover,
    &:active,
    &:focus {
        background: ${(props) => getHoveredBackground(props)};
    }
`;

export const CommonButton = styled.button`
    ${CommonCss}
`;

export const LinkButton = styled.a`
    ${CommonCss}
`;

export const ReactLinkButton = styled(Link)`
    ${CommonCss}
`;
